import { ServiceResponse } from 'loca-boot-core'
import { CoreService, IServiceParam, IServiceParamRequest } from 'loca-boot-service'
import { NioApmPlus } from '@nio-fe/nio-apm-plus'
import { getEnv } from '@nio-wad/hooks'

export class FetchMonitorHook {
  genFetch: CoreService
  constructor(genFetch: CoreService) {
    this.genFetch = genFetch
  }
  get<T>(url: string, data?: IServiceParam<T>) {
    const temp = this.genFetch.get(url, data)
    this.monitor(temp, url)
    return temp
  }

  post<T>(url: string, data?: IServiceParam<T>) {
    const temp = this.genFetch.post(url, data)
    this.monitor(temp, url)
    return temp
  }

  del<T>(url: string, data?: IServiceParam<T>) {
    const temp = this.genFetch.del(url, data)
    this.monitor(temp, url)
    return temp
  }

  put<T>(url: string, data?: IServiceParam<T>) {
    const temp = this.genFetch.put(url, data)
    this.monitor(temp, url)
    return temp
  }

  patch<T>(url: string, data?: IServiceParam<T>) {
    const temp = this.genFetch.patch(url, data)
    this.monitor(temp, url)
    return temp
  }

  request<T>(url: string, param?: IServiceParamRequest<T>) {
    const temp = this.genFetch.request(url, param)
    this.monitor(temp, url)
    return temp
  }

  getGenFetch() {
    return this.genFetch
  }

  setGenFetch(genFetch: CoreService) {
    this.genFetch = genFetch
  }

  protected monitor<T>(temp: Promise<ServiceResponse<T>>, url: string) {
    temp.then((res: ServiceResponse<T>) => {
      if (res.resultCode !== 'success') {
        const env = getEnv()
        if (env === 'prod') {
          // 只上报prod数据
          // 向APM发送普通的计数打点
          const apmInstance = NioApmPlus.getDefaultInstance()
          apmInstance?.sendEvent({
            name: 'result-code-not-success',
            categories: {
              path: url,
              result_code: res.resultCode,
              request_id: res.requestId,
              server_time: String(res.serverTime),
            },
          })

          // // 向APM发送JS异常
          // apmInstance?.captureException(new Error('result code not success'), {
          //  path: url,
          // result_code: res.resultCode,
          // request_id: res.requestId,
          // })
        }
      }
    })
  }
}
